import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Box, Select, MenuItem, FormControl, InputLabel, styled } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import {useGetLocationListQuery} from "../../../api/locations/locationsApiSlice";
import IssueReportTextField from "../../reportIssue/IssueReportTextField";
import CustomButton from "../../layout/components/CustomButton";
import LoaderOverlay from "../../layout/components/LoaderOverlay";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from '../../../redux/store';
import { IssueReportRequest, useCreateIssueReportMutation } from "../../../api/info/infoApiSlice";
import { enqueueNotification } from "../../../redux/slice/notification/notificationSlice";
import { HintsLink } from "./HintsLink";
import { getTenantName } from "../../../util";
import { Location } from "../../../redux/slice/location/locationSlice";

const DISABLED_COLOR = "#bdbdbd";

const SelectStyled = styled(Select)(({ theme, value, disabled }) => ({
  backgroundColor: theme.palette.background.default,
  "& .MuiSelect-select:focus": {
    width: "100%",
    backgroundColor: theme.palette.background.default,

  },
  height: "62px",
  "& .MuiInputBase-input": {
    color: disabled ? DISABLED_COLOR : theme.palette.primary.main,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: disabled
      ? DISABLED_COLOR
      : theme.palette.primary.contrastText,
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: disabled ? DISABLED_COLOR : theme.palette.primary.light,
    borderWidth: "1px",
  },
}));
export default function HelpAccordionList() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const tenantConfig = useSelector((state: RootState) => state.tenantConfig.config);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [issueReport, setIssueReport] = React.useState({
    email: "",
    name: "",
    bookingNumber: "",
    issueType: "",
    locationId:"",
    description: "",
  });
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [createIssueReport] = useCreateIssueReportMutation();
  const { data: locations} = useGetLocationListQuery('')
  
  console.log(issueReport, "issueReport");

  const tenantName = getTenantName();
  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const isSubmitDisabled =
    !isValidEmail(issueReport.email) ||
    !issueReport.email ||
    !issueReport.name ||
    !issueReport.issueType ||
    !issueReport.description;

  const roomRentalIssueTypes = [
        'furniture_fixtures',
        'bathroom_sanitary',
        'kitchen_appliances',
        'hvac',
        'electrical_systems',
        'plumbing_issues',
        'internet_connectivity',
        'cleaning_housekeeping',
        'pest_control',
        'safety_security',
        'exterior_outdoor',
        'noise_neighbor',
        'other_miscellaneous',
    ].map((key) => ({
        text: t(`report_issue.issue_types.${key}`),
        value: key,
    }));

    const nonRoomRentalIssueTypes = [
        'general_questions',
        'locker_technical_issue',
        'locker_user_issue',
        'equipment_damaged_dirty',
        'locker_damaged_dirty',
        'emergency_person_danger',
        'payment_booking_issue',
        'other_not_listed',
    ].map((key) => ({
        text: t(`report_issue.issue_types.${key}`),
        value: key,
    }));
    const issueTypeOptions = tenantName === "neuland" ? roomRentalIssueTypes : nonRoomRentalIssueTypes;

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  React.useEffect(() => {
      if (locations?.length === 1 && !issueReport.locationId) {
          setIssueReport({ ...issueReport, locationId: locations[0].id });
      }
  }, [locations, issueReport, setIssueReport]);


  const submitDamageReport = async () => {
    try {
        setLoading(true);
        const payload: IssueReportRequest = {
            email: issueReport.email,
            name: issueReport.name,
            bookingNumber: issueReport.bookingNumber || undefined,
            issueType: issueReport.issueType,
            locationId: issueReport.locationId,
            description: issueReport.description,
        };
        const response = await createIssueReport(payload).unwrap();

        console.log("response", response);

        // Reset form after successful submission
        setIssueReport({
          email: "",
          name: "",
          bookingNumber: "",
          issueType: "",
          locationId: "",
          description: "",
        });
        setExpanded(false);

        // Show success notification
        dispatch(
            enqueueNotification({
                message: t("report_issue.help.success_message"),
                severity: "success",
            })
        );
    } catch (error: any) {
        console.log("eroror", error);
        dispatch(
            enqueueNotification({
                message: error.data.message,
                severity: "error",
            })
        );
    } finally {
        setLoading(false);
    }
  };

  return (
    <>
      <p
        style={{
          fontSize: "2.125rem",
          fontWeight: 500,
          lineHeight: 1.2,
          margin: 0,
          textTransform: "none",
          paddingBottom: "10px",
        }}
      >
        {t("report_issue.help.header")}
      </p>
      <Box
        sx={{
          border: "1px solid",
          borderColor: "black",
          borderLeft: "none",
          borderRight: "none",
        }}
      >
        <Accordion
          expanded={expanded !== "panel1"}
          onChange={handleAccordionChange("panel1")}
          sx={{
            margin: 0,
            backgroundColor: "background.default",
            border: "none",
            boxShadow: "none",
          }}
        >
          <AccordionSummary aria-controls="panel1-content" id="panel1-header">
            <div className="flex flex-col">
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "20px",
                  margin: 0,
                }}
              >
                {t("report_issue.help.talk_to_support")}
              </p>
              {expanded === "panel1" && tenantConfig?.contact?.phone && (
                <p className="mb-4">{tenantConfig.contact.phone}</p>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              display: "block",
              marginLeft: "16px",
              marginBottom: "16px",
              padding: 0,
              opacity: 1,
            }}
          >
            {tenantConfig?.contact?.phone && (
              <div>
                <p className="m-0">
                  <HintsLink className="no-underline" href={`tel:${tenantConfig.contact.phone}`}>
                    {tenantConfig.contact.phone}
                  </HintsLink>
                </p>
              {tenantConfig?.contact?.email && (
                <p className="m-0">
                  <br />
                  <HintsLink className="no-underline" href={`mailto:${tenantConfig.contact.email}`}>
                    {tenantConfig.contact.email}
                  </HintsLink>
                </p>
              )}
            </div>
            )}
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleAccordionChange("panel2")}
          sx={{
            margin: 0,
            backgroundColor: "background.default",
            boxShadow: "none",
            border: "none",
            borderTop: "1px solid",
          }}
        >
          <AccordionSummary aria-controls="panel2-content" id="panel2-header">
            <div className="flex flex-col">
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "20px",
                  margin: 0,
                }}
              >
                {t("report_issue.help.report_issue")}
              </p>
              {expanded !== "panel2" && (
                <p className="mb-4">{t("report_issue.help.use_our_form")}</p>
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              display: "block",
              marginLeft: "16px",
              marginBottom: "16px",
              padding: 0,
              opacity: 1,
            }}
          >
            <p className="mb-4">{t("report_issue.help.use_our_form")}</p>
            <Box
              display="flex"
              flexDirection="column"
              width="100%"
              height="100%"
            >
              <Box flex={1}>
                <Box mb={2}>
                  <IssueReportTextField
                    numsRows={1}
                    title={`${t("report_issue.help.email")}*`}
                    value={issueReport.email}
                    onChange={(value)=> setIssueReport({...issueReport, email: value})}
                  />
                </Box>
                <Box mb={2}>
                  <IssueReportTextField
                    numsRows={1}
                    title={`${t("report_issue.help.name")}*`}
                    value={issueReport.name}
                    onChange={(value)=> setIssueReport({...issueReport, name: value})}
                  />
                </Box>
                <Box mb={2}>
                  <IssueReportTextField
                    numsRows={1}
                    title={`${t("report_issue.help.booking_number")}`}
                    value={issueReport.bookingNumber}
                    onChange={(value)=> setIssueReport({...issueReport, bookingNumber: value})}
                  />
                </Box>
                <Box mb={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t("report_issue.select_issue_type")}</InputLabel>
                    <SelectStyled
                     value={issueReport.issueType || ''}
                      label={t("report_issue.select_issue_type")}
                      onChange={(event) => setIssueReport({...issueReport, issueType: event.target.value as string})}
                    >
                     <MenuItem value="" disabled>
                      {t('report_issue.select_issue_type')}
                    </MenuItem>

                    {issueTypeOptions.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.text}
                      </MenuItem>
                    ))}
                    </SelectStyled>
                  </FormControl>
                </Box>
                <Box mb={2}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t("book_location.select_location")}</InputLabel>
                    <SelectStyled
                     value={issueReport.locationId}
                      label={t("book_location.select_location")}
                      onChange={(event) => setIssueReport({...issueReport, locationId: event.target.value as string})}
                    >
                    
                    <MenuItem value="" disabled>
                      {t("book_location.select_location")}
                    </MenuItem>

                    {locations?.map((loc: Location) => (
                      <MenuItem key={loc.id} value={loc.id}>
                        {loc.name}
                      </MenuItem>
                    ))}
                    </SelectStyled>
                  </FormControl>
                </Box>
                <Box mb={2}>
                  <IssueReportTextField
                    numsRows={5}
                    title={`${t("report_issue.issue_description")}*`}
                    value={issueReport.description}
                    onChange={(value)=> setIssueReport({...issueReport, description: value})}
                  />
                </Box>
              </Box>
              <div className="bg-[#EDF0F5] text-gray-800 p-2 rounded-lg mt-2">
                <p style={{ margin: 0 }}>
                  <Trans
                    i18nKey={"report_issue.help.note"}
                    components={{
                      bold: (
                        <span
                          style={{
                            fontWeight: "bold",
                          }}
                        ></span>
                      ),
                    }}
                  />
                </p>
              </div>
              <Box pt={3} display="flex" justifyContent="center">
                  <CustomButton
                    isButtonDark={true}
                    fullWidth={true}
                    onClick={submitDamageReport}
                  disabled={isSubmitDisabled}
                    children={t("report_issue.report_issue")}
                  />
              </Box>
              <LoaderOverlay open={loading} />
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}